// Single source of truth for business contact details, used across
// header, footer, forms and CTAs instead of hardcoded strings per file.
export const business = {
  name: "Vasavi Structures",
  siteUrl: "https://www.vasavistructure.com",
  phone: {
    display: "+91 83280 50253",
    href: "tel:+918328050253",
  },
  whatsapp: {
    number: "918328050253",
    href: "https://api.whatsapp.com/send?phone=918328050253&text=Hello,%20I%20have%20a%20question%20about%20Vasavi%20Structures",
  },
  email: {
    display: "Vasavipebstructure@gmail.com",
    href: "mailto:Vasavipebstructure@gmail.com",
  },
  address: {
    line: "Peerzadiguda, Hyderabad, Telangana",
  },
  hours: "MON - SAT 09:00 - 19:00",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61584115992971",
    instagram: "https://www.instagram.com/vasavistructure/",
    linkedin: "https://www.linkedin.com/company/110321714/admin/dashboard/",
  },
};

export default business;
